import React, { type FC } from 'react'
import { Input } from '@mui/material'

import { Translation } from '../../../../domain'

import { useTranslator } from '../../Internationalization'
import { useAppUsecase } from '../../State'

export const TopicsInput: FC = () => {
    const translator = useTranslator()
    const filter = useAppUsecase('filterSandboxUsecase')

    return (
        <Input
            data-testid="rule-engine-topics-input"
            fullWidth
            placeholder={translator.formatTranslation(Translation.TOPIC_PLACEHOLDER)}
            onChange={({ target }) => filter.selectTopics(target.value ? [target.value] : [])}
        />
    )
}
